export default __webpack_public_path__ + "static/media/postgres.29aef667.svg";